export default function ProcRightLogo() {
  return (
    <svg
      width="15"
      height="11"
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14355_106564)">
        <path
          d="M10.9833 7.58145C9.88919 7.58431 8.79417 7.58621 7.7001 7.58907V10.8097H0.0166149C0.0117989 10.7317 0.00505638 10.6774 0.00505638 10.6222C0.00505638 7.1665 0.00505733 3.70983 0.00120544 0.25411C0.00120544 0.0580549 0.0599537 -9.53674e-07 0.260275 0.000950813C2.27794 0.00761223 4.29656 0.00475788 6.31422 0.00570965C6.38356 0.00570965 6.45291 0.0161781 6.52418 0.0218887V3.23016H3.29303V7.59478C4.7781 7.59478 6.24295 7.59478 7.70684 7.59478V4.39126H10.963C10.963 4.66727 10.9621 4.91947 10.963 5.17168C10.9678 5.97684 10.9727 6.782 10.9784 7.58621H14.2173V10.8173H10.9833C10.9833 9.72855 10.9833 8.655 10.9833 7.58145Z"
          fill="white"
        />
        <path
          d="M7.70606 7.59458H3.29225L3.29225 3.22996H6.52339L6.52339 0.0216932C6.45213 0.0159826 6.38278 0.00551319 6.31344 0.00551319C4.29578 0.00551319 2.27716 0.00741673 0.259494 0.000754356C0.0591731 0.000754356 0.000424385 0.0578585 0.000424385 0.253914C0.00523996 3.70963 0.00427628 7.1663 0.00427628 10.622C0.00427628 10.6772 0.0110173 10.7315 0.0158329 10.8095H7.69932C7.69932 9.73311 7.69932 8.66051 7.69932 7.58792L7.7051 7.59363L7.70606 7.59458Z"
          fill="#006039"
        />
        <path
          d="M10.9833 7.58145V10.8173H14.2173V7.58621H10.9775L10.9833 7.5805V7.58145Z"
          fill="#006039"
        />
        <path
          d="M10.9771 7.5861C10.9723 6.78094 10.9665 5.97578 10.9617 5.17157C10.9608 4.91936 10.9617 4.66716 10.9617 4.39115H7.70554C7.70554 5.45518 7.70554 6.52492 7.70554 7.59466L7.69976 7.58895C8.79383 7.5861 9.88885 7.5842 10.9829 7.58134L10.9771 7.58705V7.5861Z"
          fill="#006039"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9715 4.47055C10.9715 4.47277 10.9716 4.47498 10.9716 4.4772V4.47853L10.9795 4.47053C10.9768 4.47054 10.9742 4.47054 10.9715 4.47055ZM10.9715 4.46256C10.9715 4.46523 10.9715 4.46789 10.9715 4.47055C10.2231 4.47254 9.47434 4.4742 8.72558 4.47586C7.97681 4.47752 7.22803 4.47918 6.47959 4.48117V4.4892L6.47165 4.4812C6.4743 4.48119 6.47694 4.48118 6.47959 4.48117V0.00115919L10.9715 4.46256Z"
          fill="#25B35A"
        />
      </g>
      <defs>
        <clipPath id="clip0_14355_106564">
          <rect
            width="10.8173"
            height="14.217"
            fill="white"
            transform="matrix(0 -1 -1 0 14.217 10.8173)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
